import styled from "styled-components";
import { breakpoints } from "styles";

export const FreeUserHeroContainer = styled.section`
  background: url("/assets/kelas-live/free-hero-decor-bottom-left.svg") left 0px
      bottom 0px/ 200px no-repeat,
    url("/assets/kelas-live/free-hero-decor-top-right.svg") right 0px top 0px/200px
      no-repeat,
    ${({ theme }) => theme.colors.brand[800]};
  display: flex;
  padding: 0;

  @media ${breakpoints.tablet} {
    background: url("/assets/kelas-live/free-hero-decor-bottom-left.svg") left
        bottom no-repeat,
      url("/assets/kelas-live/free-hero-decor-top-right.svg") right top
        no-repeat,
      ${({ theme }) => theme.colors.brand[800]};
  }
`;

export const FreeUserHeroDetailsContainer = styled.div`
  flex-grow: 1;
  padding: 30px 0 30px 30px;
  @media ${breakpoints.tablet} {
    padding: 50px 0 50px 50px;
  }
  @media ${breakpoints.laptop} {
    padding: 100px 0 100px 100px;
  }
`;

export const FreeUserName = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  font-weight: bold;
  margin: 0 0 4px 0;

  @media ${breakpoints.tablet} {
    margin: 0 0 8px 0;
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
`;

export const FreeUserPackageDetails = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: bold;
  margin: 0 0 4px 0;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  }
`;

export const FreeUserJoinButton = styled.a`
  --webkit-appearance: none;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.brand["800"]};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 4px;
  box-shadow: none;
  border: none;
  cursor: pointer;
  max-width: 160px;
  white-space: nowrap;
  margin: 8px 0;
  text-decoration: none;

  @media ${breakpoints.tablet} {
    margin: 32px 0;
  }
`;

export const FreeUserHeroImageWrapper = styled.figure`
  margin: 0;
  width: 300px;
  height: 180px;
  position: relative;
  justify-self: end;
  align-self: end;

  @media ${breakpoints.tablet} {
    height: 400px;
    width: 400px;
  }
`;

export const FreeUserHeroImage = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
